import {
    FETCH_NOTES_REQUEST,
    GET_NOTES,
    NOTES_ERROR,
    GET_TAG_TYPES,
    GET_EMPTY_NOTE,
} from '../ActionTypes';

const initialState = {
    notes: [],
    emptyNote: {},
    practiceID: '',
    newNote: '',
    loading: true,
    error: '',
    storedNotes: [],
    tagTypes: [],
    tags: [],
    currentPage: 1,
};

const noteReduction = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_NOTES_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_NOTES:
            return {
                ...state,
                notes: action.payload,
                loading: false,
                error: '',
            };
        case NOTES_ERROR:
            return {
                ...state,
                notes: [],
                loading: false,
                error: action.payload,
            };
        case GET_TAG_TYPES:
            return {
                ...state,
                tagTypes: action.payload,
            };
        case GET_EMPTY_NOTE:
            return {
                ...state,
                emptyNote: action.payload,
            };
        default:
            return state;
    }
};

export default noteReduction;
